// PERMISSIONS_DISABLED: loader cortocircuitado — no consulta el backend
// y marca permissionsLoading en false de inmediato.
// Para reactivar: descomentar el bloque de abajo y eliminar este stub.
const usePermissionsLoader = () => {
  return {
    permissions: new Set(),
    permissionCodes: new Set(),
    groupedPermissions: {},
    permissionsLoading: false,
  };
};

export default usePermissionsLoader;

// PERMISSIONS_DISABLED: implementación real — descomentar para reactivar.
/*
import { useEffect, useState } from 'react';
import { useAuth } from 'context/AuthContext';
import { getUserPermissions } from 'services/roleServices';
import { buildPermissionsState } from 'permissions/helpers/buildPermissionsState';

const usePermissionsLoader = () => {
  const { isAuthenticated, token, initializing } = useAuth();

  const [permissions, setPermissions] = useState(() => new Set());
  const [permissionCodes, setPermissionCodes] = useState(() => new Set());
  const [groupedPermissions, setGroupedPermissions] = useState({});
  const [permissionsLoading, setPermissionsLoading] = useState(true);

  useEffect(() => {
    if (!isAuthenticated) {
      setPermissions(new Set());
      setPermissionCodes(new Set());
      setGroupedPermissions({});
      if (!initializing) setPermissionsLoading(false);
      return;
    }

    let cancelled = false;

    const load = async () => {
      setPermissionsLoading(true);
      try {
        const permissionsTree = await getUserPermissions.getPermissions();
        if (cancelled) return;
        const next = buildPermissionsState(permissionsTree);
        setPermissions(next.ids);
        setPermissionCodes(next.allowedCodes);
        setGroupedPermissions(next.grouped);
      } catch (e) {
        console.error('Error loading permissions', e);
        if (cancelled) return;
        setPermissions(new Set());
        setPermissionCodes(new Set());
        setGroupedPermissions({});
      } finally {
        if (!cancelled) setPermissionsLoading(false);
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, [isAuthenticated, token, initializing]);

  return { permissions, permissionCodes, groupedPermissions, permissionsLoading };
};

export default usePermissionsLoader;
*/
